class ModuleTranslates {
  constructor() {
    this.wrapperId = "braney_google_translate_element";
    this.googleScriptUrl = "https://translate.google.com/translate_a/element.js";
    this.init();
  }

  async init() {
    // Load script Google Translate
    await this.loadGoogleTranslateScript();

    // Khi script đã load xong và google.translate tồn tại
    if (typeof google?.translate?.TranslateElement === "function") {
      this.loadGoogleLanguages();
    } else {
      console.error("Google Translate script loaded but TranslateElement not found.");
    }
  }

  loadGoogleTranslateScript() {
    return new Promise((resolve, reject) => {
      // Nếu đã có script trong DOM → resolve ngay
      if (document.querySelector(`script[src*="translate_a/element.js"]`)) {
        if (typeof google?.translate?.TranslateElement === "function") resolve();
        else window.addEventListener("load", resolve, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = this.googleScriptUrl;
      script.async = true;

      script.onload = () => resolve();
      script.onerror = () => reject(new Error("Failed to load Google Translate script"));

      document.body.appendChild(script);
    });
  }

  loadGoogleLanguages() {
    const wrapper = document.querySelector(`#${this.wrapperId}`);
    if (!wrapper) return;

    const language = wrapper.dataset.language || "vi";

    // Khởi tạo Translate
    new google.translate.TranslateElement(
      { pageLanguage: language },
      this.wrapperId
    );

    const textinlink = wrapper.dataset.textinlink || "";
    const supporttext = wrapper.dataset.supporttext || "";
    const placeholder = wrapper.dataset.placeholder || "";

    // Theo dõi Google thêm DOM vào
    const observer = new MutationObserver(() => {
      const select = wrapper.querySelector(".goog-te-combo");
      const link = wrapper.querySelector("span > a");
    
      if (select && select.options.length > 0) {
        const firstOption = select.options[0];
        firstOption.textContent = placeholder;
      }
      if (link) {
        if (textinlink) link.setAttribute("data-textinlink", textinlink);
        if (supporttext) link.setAttribute("data-supporttext", supporttext);
        
        observer.disconnect();
      }
    });

    observer.observe(wrapper, { childList: true, subtree: true });
  }
}


export default ModuleTranslates;